// extracted by mini-css-extract-plugin
var _1 = "assets-js-common-components-MegaNav-MegaNavVariant-components-LocalNav-components-Dropdown-components-MarketingBanner-MarketingBanner-module__bannerUrl__ZRhdd";
export { _1 as "bannerUrl" }
